import { getAgeInMonths } from '../../util/patients.js';
/**
 * The patient values a prescription's total amounts are calculated with, stored on the
 * prescription so it keeps showing them after the patient's values change. Callers pass the
 * same characteristics and GFR they pass to the total-amount calculation.
 */
export function getDoseBasis(characteristics, gfr, options = {}) {
    const birthDate = (options.patient ?? characteristics?.patient)?.birthDate;
    return {
        doseBasisHeight: characteristics?.height ?? null,
        doseBasisWeight: characteristics?.weight ?? null,
        doseBasisBsa: characteristics?.bsa ?? null,
        doseBasisGfr: gfr?.gfr ?? null,
        doseBasisAibw: characteristics?.aibw ?? null,
        doseBasisUseAibw: characteristics ? Boolean(characteristics.useAibw) : null,
        doseBasisBsaFormula: characteristics?.bsaFormula ?? null,
        doseBasisGfrMethod: gfr?.method ?? null,
        doseBasisGfrLabTime: gfr?.labTime ?? null,
        doseBasisSerumCreatinine: gfr?.serumCreatinine ?? null,
        doseBasisSerumUnit: gfr?.serumUnit ?? null,
        doseBasisAgeMonths: birthDate != null ? getAgeInMonths(birthDate, options.at ?? Date.now()) : null,
    };
}
// every column getDoseBasis saves; `satisfies` fails the build when one is missing here
const DOSE_BASIS_FLAGS = {
    doseBasisHeight: true,
    doseBasisWeight: true,
    doseBasisBsa: true,
    doseBasisGfr: true,
    doseBasisAibw: true,
    doseBasisUseAibw: true,
    doseBasisBsaFormula: true,
    doseBasisGfrMethod: true,
    doseBasisGfrLabTime: true,
    doseBasisSerumCreatinine: true,
    doseBasisSerumUnit: true,
    doseBasisAgeMonths: true,
};
export const DOSE_BASIS_KEYS = Object.keys(DOSE_BASIS_FLAGS);
/** The saved dose values of `sequence`, for a copy whose total amounts are copied too (remake). */
export function copyDoseBasis(sequence) {
    return Object.fromEntries(DOSE_BASIS_KEYS.map(key => [key, sequence[key] ?? null]));
}
//# sourceMappingURL=dose-basis.js.map